// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** The general modal styling is in modals.css in
 * the css components folder. This file contains styling only for 
 * the approvals modal */

#approvalsModal .modal-body {
  margin-left: 5px;
  padding-left: 20px;
  padding-bottom: 25px;
}

/* Slight adjustment to padding / layout */
#approvalsModal .approvalsContainer {
  padding-top: 1.5rem;
  padding-bottom: 2rem;
  background-color: white;
  width: 100%;
  padding-top: 20px;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 90px;
  padding-left: 15px;
}

/* Name of the user who has a task awaiting approval */
#approvalsModal .approvalsContainer .meta > .title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

/* Make the details in a column by default */
#approvalsModal .approvalsContainer .meta {
  /*display: flex;
    flex-direction: column;*/
  line-height: 1.7rem;
}

/* The meta details should be in bold */
#approvalsModal .taskName .title,
#approvalsModal .dateCompleted .title {
  font-weight: bold;
}

#approvalsModal .taskName,
#approvalsModal .dateCompleted {
  margin-top: -0.2rem;
}

/* approve/completed selector */
#approvalsModal .actions {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

#approvalsModal .deny {
  background: none;
  border: none;
  font-size: 16px;
  margin: 0.75rem 3rem 0rem;
  text-decoration: underline;
}

/* Some extra styling on the selector */
#approvalsModal .completedSelector {
  margin-bottom: 0.4rem;
}

#approvalsModal .mCSB_container {
  left: 0px !important;
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/approvalsModal.css"],"names":[],"mappings":"AAAA;;wBAEwB;;AAExB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE;4BAC0B;EAC1B,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/** The general modal styling is in modals.css in\n * the css components folder. This file contains styling only for \n * the approvals modal */\n\n#approvalsModal .modal-body {\n  margin-left: 5px;\n  padding-left: 20px;\n  padding-bottom: 25px;\n}\n\n/* Slight adjustment to padding / layout */\n#approvalsModal .approvalsContainer {\n  padding-top: 1.5rem;\n  padding-bottom: 2rem;\n  background-color: white;\n  width: 100%;\n  padding-top: 20px;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  min-height: 90px;\n  padding-left: 15px;\n}\n\n/* Name of the user who has a task awaiting approval */\n#approvalsModal .approvalsContainer .meta > .title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n/* Make the details in a column by default */\n#approvalsModal .approvalsContainer .meta {\n  /*display: flex;\n    flex-direction: column;*/\n  line-height: 1.7rem;\n}\n\n/* The meta details should be in bold */\n#approvalsModal .taskName .title,\n#approvalsModal .dateCompleted .title {\n  font-weight: bold;\n}\n\n#approvalsModal .taskName,\n#approvalsModal .dateCompleted {\n  margin-top: -0.2rem;\n}\n\n/* approve/completed selector */\n#approvalsModal .actions {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n\n#approvalsModal .deny {\n  background: none;\n  border: none;\n  font-size: 16px;\n  margin: 0.75rem 3rem 0rem;\n  text-decoration: underline;\n}\n\n/* Some extra styling on the selector */\n#approvalsModal .completedSelector {\n  margin-bottom: 0.4rem;\n}\n\n#approvalsModal .mCSB_container {\n  left: 0px !important;\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
